import { registerTour } from '@/features/tours';
import { FEATURE_FLAGS } from '@/features/featureFlags';
import { bulkActionsStep, listStep, searchFiltersStep, uploadStep } from './steps';

export const DRAWINGS_LIST_TOUR_ID = 'drawings.list';

registerTour({
  id: DRAWINGS_LIST_TOUR_ID,
  name: 'Drawings',
  version: 1,
  featureFlagKey: FEATURE_FLAGS.DRAWINGS.id,
  steps: [
    {
      id: 'welcome',
      title: 'Welcome to Drawings',
      body:
        'A central place to view, mark up, and revise every drawing on the ' +
        'project. Upload PDFs and we\u2019ll auto-extract drawing numbers, ' +
        'titles, and disciplines so they organize themselves.',
    },
    uploadStep,
    searchFiltersStep,
    bulkActionsStep,
    listStep,
  ],
});
